// extracted by mini-css-extract-plugin
export default {"container":"contact_container__lBnBc","title":"contact_title__M5Mak","subtitle":"contact_subtitle__0YnMP","icon":"contact_icon__67ltd"};